import { useState } from "react";
import DesignDocDetail from "./DesignDocDetail";
import DesignDocVerUpload from "./DesignDocVerUpload";

export default function DesignDocView({ docDetail, onReload }) {
  const [tab, setTab] = useState("detail"); // "detail" | "upload"

  if (!docDetail) return null;

  return (
    <div className="space-y-4">
      {/* 탭 메뉴 */}
      <div className="flex border-b">
        <div className="inline-flex space-x-2">
          <button
            onClick={() => setTab("detail")}
            className={`px-4 py-2 text-sm rounded-t-md transition ${
              tab === "detail"
                ? "bg-indigo-50 text-indigo-700 border-b-2 border-indigo-600 font-semibold"
                : "text-slate-500 hover:text-slate-700"
            }`}
          >
            상세보기
          </button>
          <button
            onClick={() => setTab("upload")}
            className={`px-4 py-2 text-sm rounded-t-md transition ${
              tab === "upload"
                ? "bg-indigo-50 text-indigo-700 border-b-2 border-indigo-600 font-semibold"
                : "text-slate-500 hover:text-slate-700"
            }`}
          >
            새 버전 업로드
          </button>
        </div>
      </div>

      {/* 탭 내용 */}
      <div className="pt-2">
        {tab === "detail" && <DesignDocDetail docDetail={docDetail} />}
        {tab === "upload" && (
          <DesignDocVerUpload documentId={docDetail.id} onUploaded={onReload} />
        )}
      </div>
    </div>
  );
}
